import type { HelpArticleId } from "@/lib/registrant-help/types";

/** Help Center routes stay reachable during profile setup and email verification. */
export function isRegistrantHelpPath(pathname: string): boolean {
  return (
    pathname === "/registrant/help" ||
    pathname.startsWith("/registrant/help/") ||
    pathname === "/omt-ams/help" ||
    pathname.startsWith("/omt-ams/help/")
  );
}

/** Help article for the dashboard header, based on the selected workspace tab. */
export function getDashboardContextHelpArticleId(tab: string): HelpArticleId {
  switch (tab) {
    case "invoices":
      return "invoices";
    case "payments":
      return "payments";
    case "inspections":
      return "inspections";
    case "unregistered-properties":
      return "unregistered-properties";
    case "users":
      return "user-management";
    case "needs-attention":
      return "needs-attention";
    case "compliance-issues":
      return "compliance-issues";
    case "balance-due":
    case "renewable":
    case "inactive":
      return "registrations";
    default:
      return "dashboard";
  }
}
